import React, { useState } from "react";
import {
  Button,
  Chip,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  CircularProgress,
} from "@mui/material";
import VoucherModal from "../../../common/Modals/VoucherModal";
import { useNavigate } from "react-router-dom";
import "./voucherTable.css";
import formatDate from "../../../common/Format/FormatDate";
import { useAuthStore } from "../../../store/zustand/authStore";

export const statusLabels = {
  approved: "Confirmado",
  rejected: "Rechazado",
  pending: "Pendiente",
  canceled: "Cancelado",
  refunded: "Reembolsado",
};

const VoucherTableBody = ({ data, updatePaymentStatus }) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [paymentId, setPaymentId] = useState(0);
  const [paymentStatus, setPaymentStatus] = useState(undefined);
  const [loadingRows, setLoadingRows] = useState({});
  const [method, setMethod] = useState("");
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const [orderID, setOrderID] = useState(null);
  const [paymentInfo, setPaymentInfo] = useState(null);
  const [paymentInfomation, setPaymentInformation] = useState(null);

  const handleOpenModal = (
    imageSrc,
    id,
    status,
    method,
    orderId,
    paymentInfo
  ) => {
    setSelectedImage(imageSrc);
    setPaymentId(id);
    setPaymentStatus(status);
    setOpenModal(true);
    setMethod(method);
    setOrderID(orderId);
    setPaymentInfo(paymentInfo);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
    setPaymentId(null);
    setPaymentStatus(null);
    setOpenModal(false);
    setMethod(null);
    setOrderID(null);
    setPaymentInfo(null);
    setPaymentInformation(null);
  };

  const goToProfile = async (id) => {
    const rute = "/usuarios/" + id;
    navigate(rute);
  };

  const handleStatusChange = (paymentId, newStatus) => {
    setLoadingRows((prev) => ({ ...prev, [paymentId]: true }));
    updatePaymentStatus({ paymentId, newStatus });
    setTimeout(() => {
      setLoadingRows((prev) => ({ ...prev, [paymentId]: false }));
    }, 1000);
  };

  return (
    <TableBody>
      {data?.map((row, index) => {

        const isLoading = loadingRows[row.id];
        return (
          <TableRow key={index}>
            <TableCell
              onClick={() => goToProfile(row?.orders?.user?.id)}
              className="rowhover"
            >
              <Typography color="text.primary" fontWeight="400">
                {row?.orders?.user?.name} {row?.orders?.user?.lastname}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography color="text.secondary" fontWeight="400">
                {row?.orders?.user?.email}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography color="text.secondary" fontWeight="400">
                {row?.orders?.user?.dni}
              </Typography>
            </TableCell>

            <TableCell>
              <Typography color="text.secondary" fontWeight="400">
                {row?.orders?.createdAt
                  ? formatDate(row?.orders?.createdAt)
                  : "no hay información"}
              </Typography>
            </TableCell>

            <TableCell>
              <Typography color="text.secondary" fontWeight="400">
                {row?.method}
              </Typography>
            </TableCell>

            <TableCell>
              {isLoading ? (
                <CircularProgress size={24} />
              ) : (
                <Chip
                  label={statusLabels[row.status] || ""}
                  sx={{
                    bgcolor:
                      row?.status === "approved"
                        ? "#a9dda9" // verde claro
                        : row?.status === "rejected"
                        ? "#dea4a7" // rojo claro
                        : row?.status === "canceled"
                        ? "#debea4" // marrón claro
                        : row?.status === "refunded"
                        ? "#b2b2b2" // gris claro
                        : row?.status === "pending"
                        ? "#9ec9e3" // azul claro
                        : "#ffffff",
                    color: "#333",
                  }}
                />
              )}
            </TableCell>

            <TableCell>
              {!user?.admin_users?.PAYMENTS?.WRITE[0] ? (
                ""
              ) : (
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ color: "white" }}
                  onClick={() =>
                    handleOpenModal(
                      row?.voucherLink,
                      row?.id,
                      row?.status,
                      row.method,
                      row?.orderId,
                      row?.paymentInfo?.externalId
                    )
                  }
                >
                  Ver
                </Button>
              )}
            </TableCell>
          </TableRow>
        );
      })}
      <VoucherModal
        open={openModal}
        onClose={handleCloseModal}
        imageSrc={selectedImage}
        paymentId={paymentId}
        status={paymentStatus}
        updatePaymentStatus={handleStatusChange}
        method={method}
        orderID={orderID}
        paymentInfo={paymentInfo}
        paymentInfomation={paymentInfomation}
        setPaymentInformation={setPaymentInformation}
      />
    </TableBody>
  );
};

export { VoucherTableBody };
